<template>
  <v-container fill-height>
    <v-layout row wrap align-center>
      <v-flex>
        <v-avatar
          width="400px"
          height="216px"
          class="profile rounded-lg"
          @click="openCropper"
        >
          <image-cropper
            v-model="showCropperModal"
            :aspect-ratio="16 / 9"
            @change="onChangeImage"
          />

          <div class="cover-container" v-if="imageSource || avatarImage">
            <v-img
              :src="imageSource && !imageChanged ? imageSource : avatarImage"
            ></v-img>
          </div>
          <div class="cover-container pt-6" v-else>
            <v-icon class="mt-10 mb-1" size="50">{{ icons.camera }}</v-icon>
            <div class="grey--text text--darken-2">Upload Cover Photo</div>
          </div>
        </v-avatar>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mdiCamera } from '@mdi/js'
import ImageCropper from '@/components/modals/ImageCropper'

export default {
  components: {
    ImageCropper,
  },

  props: {
    imageSource: {
      type: String,
      default: null,
    },
  },

  data() {
    return {
      showCropperModal: false,
      imageChanged: false,
      avatarImage: null,
      icons: {
        camera: mdiCamera,
      },
    }
  },

  methods: {
    openCropper() {
      this.showCropperModal = true
    },

    onChangeImage(blob, image) {
      if ((blob.size / 1024).toFixed(2) < 4096) {
        this.imageChanged = true
        const reader = new FileReader()
        reader.onload = (e) => {
          this.avatarImage = e.target.result
        }
        reader.readAsDataURL(blob)
        this.$emit('change', blob)
      } else {
        this.$emit('error')
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.cover-container {
  background-color: #f0f3f4;
  width: 400px;
  height: 216px;
  box-shadow: 4px 4px 25px #a9a9a9;

  &:hover {
    cursor: pointer;
    opacity: 0.8;
  }
}
</style>
